import { call, put, takeEvery } from "redux-saga/effects";
import { types } from "../action-types";
import { getInviteTrackingInvitesApi } from "../../API/inviteTrackingApi";

function* inviteTrackingInvitesSaga(params) {
  try {
    const response = yield call(() => getInviteTrackingInvitesApi(params.payload));
    if (!response) {
      yield put({ type: types.FETCH_INVITE_TRACKING_INVITES_FAILURE });
      return;
    }
    yield put({
      type: types.FETCH_INVITE_TRACKING_INVITES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({ type: types.FETCH_INVITE_TRACKING_INVITES_FAILURE, error });
  }
}

export function* watchInviteTrackingInvitesSaga() {
  yield takeEvery(
    types.FETCH_INVITE_TRACKING_INVITES,
    inviteTrackingInvitesSaga,
  );
}
